/**
 * Analytics events for the Tournaments section.
 *
 * Proposal summary:
 * - Navigation: page views and back/context switches.
 * - Discovery: sidebar cards, join/spectate, and CTA buttons.
 * - Picking: search, categories, and category assets (tournament context).
 * - Allocation: open/close modal, submit success/error, remove stock flow.
 * - Engagement: FAQ/how-it-works, leaderboard (if needed later).
 */
export enum TournamentsEvents {
  // ----- Navigation & page views -----
  VIEWED_TOURNAMENTS_HOME = 'TOURNAMENTS:viewed_tournaments_home',
  VIEWED_TOURNAMENT_DETAIL = 'TOURNAMENTS:viewed_tournament_detail',
  VIEWED_PICKING = 'TOURNAMENTS:viewed_picking',
  VIEWED_PICKING_CATEGORY = 'TOURNAMENTS:viewed_picking_category',
  VIEWED_STOCK_ALLOCATION = 'TOURNAMENTS:viewed_stock_allocation',

  // ----- Tournament list / sidebar / cards -----
  CLICK_TOURNAMENT_CARD = 'TOURNAMENTS:click_tournament_card',
  CLICK_JOIN_NEXT_TOURNAMENT = 'TOURNAMENTS:click_join_next_tournament',
  CLICK_JOIN = 'TOURNAMENTS:click_join',
  CLICK_JOIN_ERROR = 'TOURNAMENTS:click_join_error',
  CLICK_SPECTATE = 'TOURNAMENTS:click_spectate',
  CLICK_PICK_STOCKS = 'TOURNAMENTS:click_pick_stocks',
  CLICK_VIEW_STOCKS = 'TOURNAMENTS:click_view_stocks',
  CLICK_VIEW_RESULTS = 'TOURNAMENTS:click_view_results',
  CLICK_VIEW_PORTFOLIO = 'TOURNAMENTS:click_view_portfolio',

  // ----- Stock picking flow -----
  CLICK_PICKING_SEARCH_RESULT = 'TOURNAMENTS:click_picking_search_result',
  CLICK_CATEGORY = 'TOURNAMENTS:click_category',
  CLICK_CATEGORY_ASSET = 'TOURNAMENTS:click_category_asset',
  CLICK_RELATED_ASSET = 'TOURNAMENTS:click_related_asset',

  // ----- Allocation modal -----
  OPEN_ALLOCATION_MODAL = 'TOURNAMENTS:open_allocation_modal',
  CLOSE_ALLOCATION_MODAL = 'TOURNAMENTS:close_allocation_modal',
  SUBMIT_ALLOCATION = 'TOURNAMENTS:submit_allocation',
  SUBMIT_ALLOCATION_SUCCESS = 'TOURNAMENTS:submit_allocation_success',
  SUBMIT_ALLOCATION_ERROR = 'TOURNAMENTS:submit_allocation_error',

  // ----- Remove stock -----
  CLICK_REMOVE_STOCK = 'TOURNAMENTS:click_remove_stock',
  CONFIRM_REMOVE_STOCK = 'TOURNAMENTS:confirm_remove_stock',
  REMOVE_STOCK_SUCCESS = 'TOURNAMENTS:remove_stock_success',
  REMOVE_STOCK_ERROR = 'TOURNAMENTS:remove_stock_error',

  // ----- Engagement -----
  CLICK_HOW_IT_WORKS = 'TOURNAMENTS:click_how_it_works',

  // ----- Download app -----
  GET_APP_DOWNLOAD_CLICK = 'TOURNAMENTS:get_app_download_click',
}
